<template>
    <div>
        <v-col
            class="pa-0 font-weight-regular position-relative d-flex justify-center align-center"
        >
            <div style="z-index: 10;">
                <slot />
            </div>
            <img
                src="/img/user/points.svg"
                :height="height"
                :width="width"
                class="position-absolute"
            />
        </v-col>
    </div>
</template>
<script>
export default {
    props: {
        height: { type: [Number, String], default: 75 },
        width: { type: [Number, String], default: 75 },
    },
}
</script>
